<template>
	<div class="form-group">
		<div class="flex flex-wrap">
			<div class="flex w-full md:mt-4 overflow-hidden license-input-box border-2 border-black rounded-md box-border" v-if="licensePlateSelection">
				<div class="mr-4" v-if="!isSpecialPlate"><img src="@/assets/license_plate_background.jpg" class="h-16 max-w-none" alt="img" /></div>
				<div class="mr-4" v-if="isSpecialPlate"><img src="@/assets/license_plate_background_without_d.png" class="h-16 max-w-none" alt="img" /></div>
				<div v-if="this.isSpecialPlate" class="pr-2 mb-0 w-full mr-2 mt-3 font-bold" style="font-size: 24px">{{ specialLicensePlate }}</div>

				<div class="flex pr-4 w-full mt-3" style="align-items: start" v-else>
					<div ref="BaseInput.regularLicensePlate.firstPart" class=" mb-0 mr-2 w-full font-bold" style="font-size: 24px">
						{{ regularLicensePlate.firstPart }}
					</div>
					<div
						class="justify-center align-middle items-center flex "
						style="align-items: center; text-align: center; width: fit-content; flex-direction: column"
					>
						<div class="border-black border rounded-full mb-1 h-4 w-4 justify-center" style="align-content: center; text-align: center"></div>
						<div class="border-black border rounded-full w-5 h-5 " style="align-self: center"></div>
					</div>
					<div ref="BaseInput.regularLicensePlate.secondPart" class="pr-2 mb-0 w-full ml-2 font-bold" style="font-size: 24px">
						{{ regularLicensePlate.secondPart }}
					</div>
					<div ref="BaseInput.regularLicensePlate.thirdPart" class="mb-0 w-full font-bold" style="font-size: 24px">
						{{ regularLicensePlate.thirdPart }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LicensePlateInputShowOnly',
	inheritAttrs: false,
	props: {
		value: {},
		required: {
			default: true,
		},
	},
	data() {
		return {
			init: false,
			specialLicensePlate: null,
			regularLicensePlate: {
				firstPart: null,
				secondPart: null,
				thirdPart: null,
			},
			licensePlateSelection: null,
			options: [
				{ display: this.$t('regular_plate'), value: false },
				{ display: this.$t('special_plate'), value: true },
			],
		};
	},
	computed: {
		isSpecialPlate() {
			return this.licensePlateSelection?.value;
		},
	},
	mounted() {
		this.updateLicensePlate();
		if (this.specialLicensePlate) {
			this.licensePlateSelection = this.options[1];
		} else {
			this.licensePlateSelection = this.options[0];
		}
	},
	methods: {
		updateValue() {
			this.$emit('input', {
				isSpecial: this.isSpecialPlate,
				text: this.getLicensePlate(),
			});
		},
		getLicensePlate: function() {
			if (this.isSpecialPlate) {
				return this.specialLicensePlate;
			}
			const plate = this.regularLicensePlate;
			return (plate.firstPart ?? '') + ' ' + (plate.secondPart ?? '') + ' ' + (plate.thirdPart ?? '').trim();
		},
		updateLicensePlate() {
			const text = this.value?.text;

			if (text && text?.trim()) {
				if (this.value.isSpecial) {
					this.licensePlateSelection = this.options[1];
					this.specialLicensePlate = text;
				} else if (this.value.isSpecial !== undefined) {
					const plate = text.split(' ');

					this.licensePlateSelection = this.options[0];
					this.regularLicensePlate.firstPart = plate[0];
					this.regularLicensePlate.secondPart = plate[1];
					this.regularLicensePlate.thirdPart = plate[2];
				}
			}
		},
	},
	watch: {
		value() {
			if (!this.init) {
				this.updateLicensePlate();
				this.init = true;
			}
		},
		display() {
			this.updateLicensePlate();
		},
	},
};
</script>
